import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import styled from 'styled-components';

import { FontStyle } from '@/utils/StyleUtil';
import DailyPopupModal from '@/components/Modal/DailyPopup';

const STORAGE_KEY = 'fall-2610';

const Npay2610ModalBanner = () => {
    const router = useRouter();

    useEffect(() => {
        document.documentElement.style.setProperty('--checked-color', '#051F04');
    }, []);

    return (
        <DailyPopupModal
            storageKey={STORAGE_KEY}
            policy={{ type: 'nextWeekMonday' }}
            label="일주일간 보지 않기"
            Comp={({ close }) => (
                <Container>
                    <Title>
                        <Image
                            src="/img/event/npay-fall-2610/main.png"
                            alt="npay_main"
                            width="278"
                            height="84"
                            unoptimized
                        />
                    </Title>
                    <SubText>
                        <Image
                            src="/img/event/npay-fall-2610/subTitle.svg"
                            alt="npay_subTitle"
                            width="218"
                            height="17"
                            unoptimized
                        />
                    </SubText>
                    <Button
                        type="button"
                        onClick={() => {
                            if (window.ReactNativeWebView) localStorage.setItem('eventPageParent', '/');
                            close();
                            router.push('/event/npay-fall-261012');
                        }}
                    >
                        이벤트 자세히 보기
                    </Button>
                </Container>
            )}
        />
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    /* 960x1260 에셋은 팝업 폭(320px) 기준 420px. 그보다 낮게 잡아 하단 들판만 잘라낸다 */
    min-height: 366px;
    padding: 36px 20px 12px 20px;
    background-image: url('/img/event/npay-fall-2610/main_popup.png');
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
`;

const Title = styled.div`
    line-height: 0;
`;

const SubText = styled.div`
    position: relative;
    z-index: 1;
    font-family: 'Gumi Romance TTF';
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    ${FontStyle(16, 22.4, '400', '#ffffff', -0.2)}
`;

const Button = styled.button`
    position: relative;
    /* 배경(들판)이 깔린 하단에 붙인다 */
    margin-top: auto;
    width: 100%;
    padding: 12px 0;
    border-radius: 6px;
    background: #229dfb;
    ${FontStyle(14, 22, '500', '#fff', -1)}
`;

export default Npay2610ModalBanner;
